import React, { createContext, useContext, useEffect, useState } from 'react';
import { useAccount, useConnect } from 'wagmi';
import { ensureFarcasterMiniAppReady } from '../lib/farcasterMiniApp';

type Ctx = { isMiniApp: boolean };

const FarcasterMiniAppContext = createContext<Ctx>({ isMiniApp: false });

export function useFarcasterMiniApp(): Ctx {
  return useContext(FarcasterMiniAppContext);
}

/**
 * Signals ready(), auto-connects the host wallet, and exposes Mini App chrome padding.
 */
export function FarcasterMiniAppBootstrap({ children }: { children?: React.ReactNode }): React.JSX.Element {
  const [isMiniApp, setIsMiniApp] = useState(false);
  const { isConnected } = useAccount();
  const { connect, connectors } = useConnect();

  useEffect(() => {
    void ensureFarcasterMiniAppReady().then(setIsMiniApp);
  }, []);

  useEffect(() => {
    if (!isMiniApp || isConnected) return;
    const connector = connectors.find((c) => c.id === 'farcasterMiniApp');
    if (connector) connect({ connector });
  }, [isMiniApp, isConnected, connect, connectors]);

  return (
    <FarcasterMiniAppContext.Provider value={{ isMiniApp }}>
      <div
        style={
          isMiniApp
            ? {
                paddingTop: 'env(safe-area-inset-top)',
                paddingBottom: 'env(safe-area-inset-bottom)',
                minHeight: '100%',
              }
            : undefined
        }
      >
        {children}
      </div>
    </FarcasterMiniAppContext.Provider>
  );
}
